import React from "react";

const Blog = () => {
  const videoId = "KJ_gXUC0fZA";
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;

  // Array of blog posts with title, description, and Medium/Substack links
  const blogPosts = [
    {
      title: "Life Isn't About Finding Yourself",
      description:
        "everyone around me seemed to know what they were passionate about. I didn't. this is an essay about why that stopped mattering.",
      link: "https://adacakmak.substack.com/p/life-isnt-about-finding-yourself?r=4addfs&utm_campaign=post&utm_medium=web",
    },
    {
      title: "October Blog: A Month in the Life of a CS Student at UofT",
      description:
        "An overview of a month as a CS student at the University of Toronto.",
      link: "https://medium.com/@nevinadacakmak/october-blog-as-a-cs-student-uoft-2b5adbdd3d20",
    },
    {
      title:
        "My Journey with Tech@RBC Women’s Advisory Program: From Application to the End",
      description: "My experience with Tech@RBC Women’s Advisory Program.",
      link: "https://medium.com/@nevinadacakmak/my-journey-with-tech-rbc-womens-advisory-program-from-application-to-the-end-01369a83edc7",
    },
  ];

  return (
    <div id="blog">
      <h1>Writings</h1>
      <div className="blog-section">
        {blogPosts.map((post, index) => (
          <div key={index} className="blog-card">
            <div className="project-content">
              <h3>{post.title}</h3>
              <p>{post.description}</p>
              <a
                href={post.link}
                target="_blank"
                rel="noopener noreferrer"
                className="read-more"
              >
                Read More
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;
